export const adUnitsConstants = {
    GET_AD_UNITS_REQUEST: 'GET_AD_UNITS_REQUEST',
    GET_AD_UNITS_SUCCESS: 'GET_AD_UNITS_SUCCESS',
    GET_AD_UNITS_FAILURE: 'GET_AD_UNITS_FAILURE'
}